"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
exports.isEmpty = function (val) {
    return val == null || val.length === 0;
};
//# sourceMappingURL=object.utils.js.map